// 협상후 값이 비었을 때(가격 수정이 없었던 주문 — 崔凡 10-12 «直接下单就是最低价格») 협상전(주문가)을 최종가로 쓴다.
// 협상후 값이 있으면 이 파일은 쓰이지 않는다(호출부가 협상후를 먼저 보고, 비었을 때만 부른다).
// 협상전_상품금액·협상전_총금액·협상전_배송비 는 «이 요청 건 전체 금액»이다(단가 아님) — 단가는 수량으로 나눠서 얻는다.

// 협상후 가격 칸이 비었다: 없음·null·빈 문자열·숫자 아님·0 (0원 주문은 없다 — 운영 6천 건 표본에 0 없음)
export function isBlankNegoPrice (v) {
  if (v === undefined || v === null) return true
  if (typeof v === 'string' && v.trim() === '') return true
  return !(Number(v) > 0)
}

// 이 건의 협상전 낱개 단가(위안). 협상전_총금액-협상전_배송비 → 없으면 협상전_상품금액 을 수량으로 나눈다.
export function preUnitCny (o, qty) {
  o = o || {}
  const q = parseInt(qty) || 1
  const tot = parseFloat(o.협상전_총금액)
  const ship = parseFloat(o.협상전_배송비) || 0
  const line = tot > 0 && tot - ship > 0 ? tot - ship : parseFloat(o.협상전_상품금액)
  return line > 0 ? line / q : 0
}

// 가격 수정이 없었다 = 협상후 금액 칸(총금액·상품금액·실결제금액)이 전부 비었고 협상전 총금액은 있다 → 화면에 «未改价» 표시
export function isUnchangedPrice (o) {
  o = o || {}
  return isBlankNegoPrice(o.협상후_총금액) && isBlankNegoPrice(o.협상후_상품금액) && isBlankNegoPrice(o.협상후_실결제금액) &&
    parseFloat(o.협상전_총금액) > 0
}

// 견적서 낱개 단가(위안): 협상후 실결제÷수량 → 협상후 단가 → (비었을 때만) 협상전. 협상후가 있을 때의 값은 예전 식과 같다.
export function negoUnitCny (o, qty) {
  o = o || {}
  const q = parseInt(qty) || 1
  const paid = parseFloat(o.협상후_실결제금액)
  if (paid) return paid / q
  return parseFloat(o.협상후_상품금액) || preUnitCny(o, q)
}
